module.exports = __webpack_public_path__ + "img/val-icon-2.a94fcea7.svg";